import { render, staticRenderFns } from "./ProfileTeamToolbar.vue?vue&type=template&id=740a8956&"
import script from "./ProfileTeamToolbar.vue?vue&type=script&lang=js&"
export * from "./ProfileTeamToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTeamToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports